if (!customElements.get('custom-select-dropdown')) {
  class CustomSelectDropdown extends HTMLElement {
    connectedCallback() {
      this.nativeSelect = this.querySelector('select');
      if (!this.nativeSelect) return;
      this._build();
      this._bindEvents();
    }

    _build() {
      this.nativeSelect.style.display = 'none';
      this.trigger = this.querySelector('.custom-select__trigger');
      this.triggerText = this.querySelector('.custom-select__trigger-text');
      this.dropdown = this.querySelector('.custom-select__dropdown');
      this._syncFromNative();
    }

    _bindEvents() {
      this.trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        this._toggle();
      });

      this.dropdown.addEventListener('click', (e) => {
        const li = e.target.closest('.custom-select__option');
        if (!li || li.getAttribute('aria-disabled') === 'true') return;
        this._select(li.dataset.value);
      });

      document.addEventListener('click', this._onOutsideClick = () => this._close());
      document.addEventListener('keydown', this._onKeydown = (e) => {
        if (e.key === 'Escape') this._close();
      });

      this.nativeSelect.addEventListener('change', () => this._syncFromNative());
    }

    _toggle() {
      this.dropdown.hidden ? this._open() : this._close();
    }

    _open() {
      this.dropdown.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.classList.add('is-open');
    }

    _close() {
      this.dropdown.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
      this.classList.remove('is-open');
    }

    _select(value) {
      this.nativeSelect.value = value;
      this.nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      this.nativeSelect.dispatchEvent(new Event('input', { bubbles: true }));
      this._close();
      const name = this.nativeSelect.name;
      if (name) {
        document.querySelectorAll(`custom-select-dropdown select[name="${name}"]`).forEach((sel) => {
          if (sel === this.nativeSelect) return;
          sel.value = value;
          sel.closest('custom-select-dropdown')?._syncFromNative();
        });
      }
    }

    _syncFromNative() {
      const selectedOpt = this.nativeSelect.options[this.nativeSelect.selectedIndex];
      if (selectedOpt) this.triggerText.textContent = selectedOpt.text;
      this.dropdown.querySelectorAll('.custom-select__option').forEach((li) => {
        li.setAttribute('aria-selected', li.dataset.value === this.nativeSelect.value ? 'true' : 'false');
      });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onOutsideClick);
      document.removeEventListener('keydown', this._onKeydown);
    }
  }

  customElements.define('custom-select-dropdown', CustomSelectDropdown);
}
